import { useMemo } from 'react';
import { ImageStyle, StyleProp } from 'react-native';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBUserImage } from '@shared/components/image';
import { MBSeparator } from '@shared/components/list';
import { API } from '@shared/types/api';
import { i18n } from '@shared/util/i18n';

export interface MBSeenByListProps {
  seen: API.ShortUserFragment[];
  notSeen: API.ShortUserFragment[];
  keyword: string;
}

const userImageStyle: StyleProp<ImageStyle> = {
  width: 24,
  height: 24,
  borderRadius: 12,
  overflow: 'hidden',
};

export function MBSeenByList({ seen, notSeen, keyword }: MBSeenByListProps) {
  const seenList = useMemo(() => {
    return seen.filter(user => user.fullName.toLowerCase().includes(keyword.toLowerCase()));
  }, [seen, keyword]);

  const notSeenList = useMemo(() => {
    return notSeen.filter(user => user.fullName.toLowerCase().includes(keyword.toLowerCase()));
  }, [notSeen, keyword]);

  return (
    <View>
      <View
        paddingHorizontal={2}
        paddingTop={3}
        paddingBottom={2}
        style={{ backgroundColor: 'white' }}
      >
        <View paddingBottom={2}>
          <Text size="overline" weight="semibold" inactive>
            {i18n('chat.seenBySheet.seen', { count: seenList.length })}
          </Text>
        </View>
        {seenList.map((user, index) => (
          <View key={index} row centerVertically paddingBottom={1}>
            <MBUserImage size="small" user={user} style={userImageStyle} />
            <View paddingRight={1} />
            <View flex marginRight={1}>
              <Text size="body2">{user.fullName}</Text>
            </View>
          </View>
        ))}
      </View>
      <View paddingHorizontal={2}>
        <MBSeparator />
      </View>
      <View paddingHorizontal={2} flex paddingVertical={3}>
        <View paddingBottom={2}>
          <Text size="overline" weight="semibold" inactive>
            {i18n('chat.seenBySheet.notSeen', { count: notSeenList.length })}
          </Text>
        </View>
        {notSeenList.map((user, index) => (
          <View key={index} row centerVertically paddingBottom={1}>
            <MBUserImage size="small" user={user} style={userImageStyle} />
            <View paddingRight={1} />
            <View flex marginRight={1}>
              <Text size="body2">{user.fullName}</Text>
            </View>
            <Text size="body2" inactive>
              {i18n('chat.seenBySheet.notSeenLabel')}
            </Text>
          </View>
        ))}
      </View>
    </View>
  );
}
